// i18n/I18nProvider.jsx — attaches the (English-only) i18next instance to the
// React tree so any descendant can call our `useT()` / react-i18next's
// `useTranslation()`.
//
// Behavior today: identical to no i18n at all. The instance is pinned to
// English with English as the hard fallback, so every translated string
// renders exactly as the original literal. Wrapping the app in this provider is
// a no-op for users — it only makes the `t()` API available to NEW surfaces.

import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './index';

export default function I18nProvider({ children }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
